// src/api/apiPublic.js
import axios from 'axios'
import { EventBus } from '@/utils/eventBus'
// import { resolveApiBaseURL } from '@/utils/gatewayState'


const apiPublic = axios.create({
    baseURL: process.env.VUE_APP_API_GATEWAY,
    timeout: 30000,
    withCredentials: false
})

// const apiPublic = axios.create({
//     timeout: 30000,
//     withCredentials: true
// })

// apiPublic.interceptors.request.use(config => {
//     config.baseURL = resolveApiBaseURL()
//     return config
// })

export const publicRequest = async (
    url,
    method = 'get',
    paramsOrData = null,
    showLoading = true
) => {
    if (showLoading) EventBus.showLoading()

    try {
        const config = {
            url,
            method
        }

        if (method.toLowerCase() === 'get') {
            config.params = paramsOrData
        } else {
            config.data = paramsOrData
        }

        const res = await apiPublic(config)
        return res.data
    } finally {
        if (showLoading) EventBus.hideLoading()
    }
}

export default apiPublic
